import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




class OrderScanView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.quote = this.props.quote;
		
		this.closing = false;

		this.state = {
			message_text: 'scanning...',
			orders: []
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('OrderScanView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		this._scan();
	}

	async _scan() {
		if (this.quote) {
			let mvcmodule = this.getMvcModuleObject();
			let mvcmyquote = this.getMvcMyQuoteObject();
	
			let rootsessionuuid = this.props.rootsessionuuid;
			let walletuuid = this.props.currentwalletuuid;

			let currencyuuid = this.quote.currencyuuid;
			let quotehash = this.quote.txhash;

			let orders = [];
			let message_text = '';

			let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

			if (canfetch) {
				orders = await mvcmyquote.fetchOrders(rootsessionuuid, walletuuid, currencyuuid, quotehash)
				.catch(err => {
					console.log('error in OrderScanView._scan: ' + err);
				});
	
				message_text = 'found ' + (orders ? orders.length : 0) + ' orders';

				for (var i = 0; i < (orders ? orders.length : 0); i++) {
					orders[i].uuid = orders[i].txhash;

					orders[i].time = (orders[i].savetime ? orders[i].savetime/1000 : orders[i].blocktime);
					orders[i].formattedtime = mvcmodule.formatDate(orders[i].time, 'YYYY-mm-dd HH:MM:SS');

					let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, orders[i].amount);
					let amountstring = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, tokenamount);
					orders[i].amountstring = amountstring;
				}
	
				// sort descending order
				if (orders)
				orders.sort(function(a,b) {return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));});
	
			}
			else {
				/*let blockshift = 1000;
			
 				let new_orders = await mvcmyquote.scanNextBlockForOrders(rootsessionuuid, walletuuid, currencyuuid, quotehash, blockshift)
				.catch(err => {
					console.log('error in OrderScanView._scan: ' + err);
				}); */				
			}
			

			this._setState({message_text, orders})
		}	
	}
	
	async onRefreshPage() {
		console.log('OrderScanView.onRefreshPage called');
		//this._scan();
	}
	
	// end of life
	componentWillUnmount() {
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let order = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in OrderListView.onClickItem ' + err);
		});

		if (!order) {
			this.app.alert('Could not find order. Orders may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: order};

		this.app.gotoRoute('order', params);
	}

	renderItem(item){
		let formattedtime = item.formattedtime;
		let amountstring = item.amountstring;
		let hadfunds = (item.hadfunds == '1' ? 'yes' : 'no');
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{amountstring}</th>
				<th>{hadfunds}</th>
			</tr>
		);

	}

	renderList() {
		let items = this.state.orders;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Amount</th>
					<th>Had Funds</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);

	}
	
	// rendering
	render() {
		let { message_text, orders } = this.state;
		
		return (
			<div className="Container">
				{(orders && orders.length ? 
				<div>
					<div className="Title">List of Orders</div>
					<div className="TextBox">
					{message_text}
					{this.renderList()}
					</div>
				</div> :
				<></>)}
			</div>
		  );
	}
	
}


// propTypes validation
OrderScanView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {OrderScanView};
export default connect(mapStateToProps, mapDispatchToProps)(OrderScanView);

